import { OpeningTimes } from '@/ui';
import { getChannel, getDocument, getPlaceId } from '@lib/server';
import { Place } from '@types';

import { BlockBase, Wrapper } from './utils';

export async function Times({
  params,
  id,
  ...data
}: {
  showGeneral?: boolean;
  showSpecial?: boolean;
  places: { id: string }[];
  Type: { type: { label: string; value: string }[] };
} & BlockBase) {
  let times;
  const channel = await getChannel(decodeURIComponent(params.domain));

  if (!channel?.channelId) {
    return null;
  }

  if (!data.places) {
    const { placeId } = await getPlaceId(channel, decodeURIComponent(params.venue || ''));

    const { fields } = await getDocument<Place>('place', placeId || '', {
      tags: [channel.channelId],
      depth: 0,
      status: 'published',
      select: ['fields.default.times'],
    });

    times = fields?.default?.times;
  } else {
    const { fields } = await getDocument<Place>('place', data.places?.[0]?.id, {
      tags: [channel.channelId],
      depth: 0,
      status: 'published',
      select: ['fields.default.times'],
    });

    times = fields?.default.times;
  }

  if (!times) {
    return null;
  }

  return (
    <Wrapper id={id}>
      <OpeningTimes
        showGeneral={data.showGeneral}
        showSpecial={data.showSpecial}
        times={
          Boolean(data.Type?.type?.length)
            ? {
                extraTimetables: times.extraTimetables?.filter((t) =>
                  t.timetable?.type?.some((tt) => data.Type?.type?.some((ttt) => ttt.value === tt.value)),
                ),
                openingTimes: times.openingTimes?.type?.some((t) => data.Type?.type?.some((tt) => tt.value === t.value))
                  ? times.openingTimes
                  : undefined,
              }
            : times
        }
      />
    </Wrapper>
  );
}
